import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import './style.sass';

import { Routes as AppRoutes, Routes } from 'src/types/routes';
import { UserInnerBreadCrumbs } from './UserInnerBreadCrumbs';
import { AppViewModel } from 'app/viewModels';
import { CampaignInnerBreadCrumbs } from './CampaignInnerBreadCrumbs';

export const BreadCrumbs = () => {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const userId = searchParams.get(Routes.Args.UserId);
    const campaignId = searchParams.get(Routes.Args.CampaignId);
    const isDefaultUser = AppViewModel.Instance.userRole.isDefaultUser;

    const currentLocation = useMemo(() => {
        const splitedPathname = location.pathname.split('/');

        const res = splitedPathname[splitedPathname.length - 1];

        if (isDefaultUser && res === 'campaigns') {
            return 'my campaigns';
        }

        return res;
    }, [location, isDefaultUser]);

    const renderContent = () => {
        switch (currentLocation) {
            case AppRoutes.DashboardPages.UserInnerPage:

                return <UserInnerBreadCrumbs userId={userId} />;

            case AppRoutes.DashboardPages.InnerCampaign:

                return <CampaignInnerBreadCrumbs campaignId={campaignId} />;
            default:
                return (
                    <span className="bread-crumbs__current-location title-h2 dark-violet">
                        {currentLocation}
                    </span>);
        }
    };

    return (
        <div className="bread-crumbs">
            {renderContent()}
        </div>
    );
};
